import { render, staticRenderFns } from "./AddEditInsurance.vue?vue&type=template&id=24c3645b&"
import script from "./AddEditInsurance.vue?vue&type=script&lang=js&"
export * from "./AddEditInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports